import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mathematics',
  templateUrl: './mathematics.component.html',
  styleUrls: ['./mathematics.component.scss']
})
export class MathematicsComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
